import type { NavigateFunction } from 'react-router';
import type { Alert } from '../api/types/hd';
import { MODULES } from '../config/modules';
import { useUi } from '../stores/ui';
import { getDrill } from '../components/drill';

// Mockup alert hrefs are hash routes ('#/customers/at-risk'); map them onto our paths.
const MODULE_PATH: Record<string, string> = Object.fromEntries(MODULES.map((m) => [m.key, m.path]));
MODULE_PATH.overview = '/overview';
MODULE_PATH.fulfillment = '/overview';
MODULE_PATH.inventory = '/overview';
MODULE_PATH.purchasing = '/overview';
MODULE_PATH.production = '/overview';

export function openAlert(a: Alert, navigate: NavigateFunction): void {
  if (a.drill && getDrill(a.drill.id)) {
    const params = Object.fromEntries(Object.entries(a.drill.params).map(([k, v]) => [k, String(v)]));
    useUi.getState().openDrill(a.drill.id, params);
    return;
  }
  if (a.module === 'sales' && a.entityId && getDrill('channel')) {
    useUi.getState().openDrill('channel', { id: a.entityId });
    return;
  }
  navigate(MODULE_PATH[a.module] ?? '/overview');
}
